import axios from 'axios';

export default axios.create({
  baseURL: `http://admin.waifu-xorikita.ru/portfolio/`
});